<template>
	<div
		v-infinite-scroll="{ handleScroll, disabled: stopScroll }"
		:style="{ '--perPage': perPage }"
		class="bg-transparent"
	>
		<h2 class="pt-2 pb-4 text-2xl font-bold">
			Reviews
		</h2>
		<template v-if="hasReviews">
			<ReviewCard
				v-for="(review, index) in loadedReviews"
				:id="'review-' + index"
				:key="index"
				:listing-id="Number(review.listing_id)"
				:review="review"
				:user="user"
				profile="user"
				:style="{ '--index': index }"
				:can-edit="false"
				class="bg-white"
				@open-edit-modal="openEditModal"
				@open-report-modal="openReportModal"
			/>
			<ReportReviewModal
				:id="REPORT_REVIEW_MODAL"
				:reported-review="reportedReview"
			/>
		</template>

		<template v-else>
			<EmptyList
				image-src="/img/no-reviews.jpg"
				copy="The user has no reviews yet."
			/>
		</template>

		<template v-if="canEdit && false">
			<EditReviewModal
				:id="EDIT_REVIEW_MODAL"
				:profile="'user'"
				:review-edit="currentReview"
				:review-ratings="currentReview.ratings"
				:business="currentReview.business"
			/>
		</template>
	</div>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex'

import { EDIT_REVIEW_MODAL, REPORT_REVIEW_MODAL } from '@/constants/modal/names.js'

export default {
	components: {
		EditReviewModal: () => import('@/components/UI/modals/EditReviewModal.vue'),
		EmptyList: () => import('@/components/multiUse/EmptyList'),
		ReportReviewModal: () => import('@/components/UI/modals/ReportReviewModal.vue'),
		ReviewCard: () => import('@/components/multiUse/ReviewCard.vue')
	},
	data() {
		return {
			EDIT_REVIEW_MODAL,
			REPORT_REVIEW_MODAL,
			stopScroll: false,
			isMounted: false,
			page: 1,
			perPage: 15,
			reportedReview: {
				review: '',
				review_id: 0,
				listing_id: 0
			},
			currentReview: {
				reviewid: 0,
				review: '',
				business: {
					listing_id: 0,
					type: ''
				},
				ratings: {
					budtenders: 0,
					knowledge: 0,
					med: 0,
					price: 0,
					wait_time: 0
				}
			}
		}
	},
	computed: {
		userId() {
			return this.$store.state.user && this.$store.state.user.id
		},
		canEdit() {
			return this.auth.loggedIn && this.userId === this.auth.id
		},
		reportedReviewData() {
			return this.reviews.items[this.reportedReview.review_id]
		},
		hasReviews() {
			if (this.reviews && typeof this.reviews.ids === 'undefined' || !this.reviews.ids.length) {
				return false
			} else {
				return true
			}
		},
		reportData() {
			return {
				message: this.reportMessage,
				user_id: this.auth.id,
				review_id: parseInt(this.reportedReviewId),
				listing_id: this.business.listing_id,
				reason: this.selected
			}
		},
		bottomReviewId() {
			return this.loadedReviews.length - 1
		},
		loadedReviews() {
			// reviews currently loaded into the infinite-scroll
			const tempReviewsCapped = []

			if (this.hasReviews) {
				const numLoaded = this.page * this.perPage
				const tempIds = this.reviews.ids.slice(0, numLoaded)

				for (const key in tempIds) {
					tempReviewsCapped.push(this.reviews.items[tempIds[key]])
				}
			}
			return tempReviewsCapped
		},
		...mapGetters('user', [ 'reviews', 'user' ]),
		...mapGetters('business', [ 'business' ]),
		...mapGetters('auth', [ 'auth' ])
	},
	watch: {
		delay() {
			// what does this do @brad? [Bo 11/12/20]
			const myPage = this.page
			if (myPage != 1) {
				this.delay.push(this.page * this.perPage)
			}
		},
		reviews() {
			this.scroll()
		}
	},
	mounted() {
		if (this.hasReviews) {
			this.scroll()
		}

		this.isMounted = true
	},
	methods: {
		...mapMutations('modal', [ 'showModal' ]),
		openEditModal(data) {
			this.currentReview.review = this.reviews.items[data].review
			this.currentReview.reviewid = parseInt(this.reviews.items[data].reviewid)
			// set ratings data
			this.currentReview.ratings.budtenders = parseInt(
				this.reviews.items[data].budtenders
			)
			this.currentReview.ratings.wait_time = parseInt(
				this.reviews.items[data].wait_time
			)
			this.currentReview.ratings.knowledge = parseInt(
				this.reviews.items[data].knowledge
			)
			this.currentReview.ratings.med = parseInt(this.reviews.items[data].med)
			this.currentReview.ratings.price = parseInt(
				this.reviews.items[data].price
			)
			// set business data
			this.currentReview.business.listing_id = parseInt(
				this.reviews.items[data].listing_id
			)
			this.currentReview.business.type = this.reviews.items[data].business.type

			this.showModal(EDIT_REVIEW_MODAL)
		},
		openReportModal(data) {
			this.reportedReview.review = data.review
			this.reportedReview.review_id = parseInt(data.reviewid)
			this.reportedReview.listing_id = parseInt(data.listing_id)
			this.showModal(REPORT_REVIEW_MODAL)
		},
		scroll: function() {
			// looks for the last review element, if in view, trigger inifinite scroll
			window.onscroll = () => {
				const bottomMarker = document.querySelector(
					'#review-' + this.bottomReviewId
				)
				if (bottomMarker && this.isScrolledIntoView(bottomMarker)) {
					this.handleScroll()
				}
			}
		},
		isScrolledIntoView(el) {
			// check if element is in viewport
			const rect = el.getBoundingClientRect()
			const elemTop = rect.top
			const elemBottom = rect.bottom

			const isVisible = elemTop < window.innerHeight && elemBottom >= 0
			return isVisible
		},
		async handleScroll() {
			if (!this.stopScroll) {
				this.stopScroll = true

				if (this.reviews.ids.length > this.perPage * this.page) {
					this.page++
				}
			}
			this.stopScroll = false
		}
	}
}
</script>
